import uploadsservicesduiimageshutterstock_2574212135500x282Webp from "$lib/data/generated/uploads/services/DUI/image/shutterstock_2574212135 500x282.webp";

export const uploads = {
  "uploads/services/DUI/image/shutterstock_2574212135 500x282.webp": uploadsservicesduiimageshutterstock_2574212135500x282Webp
};